import React, { Fragment } from 'react'
import { Box, Card, CardContent, CardMedia, Typography, Divider } from '@mui/material'
import { CartActionsButton } from 'components'
import PriceDisplay from './PriceDisplay'

const DrawerCartView = ({ product, finalPrice, getQuantity, handleAdd, handleRemove, itemIds }) => (
  <Fragment>
    <Card
      sx={{
        p: 2,
        display: 'flex',
        alignItems: { xs: 'flex-start', sm: 'center' },
        gap: 1.5,
        height: 'auto',
        minHeight: 100,
      }}
      elevation={0}
    >
      <CardMedia
        component="img"
        sx={{ width: { xs: 88, sm: 100 }, height: { xs: 88, sm: 100 }, objectFit: 'cover', borderRadius: 1.5, flexShrink: 0 }}
        image={product.thumbnail}
        alt={product.title}
      />
      <CardContent sx={{ flex: '1 1 auto', minWidth: 0, p: 0, pb: '0 !important' }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            justifyContent: 'space-between',
            alignItems: { xs: 'stretch', sm: 'flex-start' },
            gap: { xs: 1.25, sm: 1.5 },
          }}
        >
          <Box sx={{ minWidth: 0, maxWidth: { xs: '100%', sm: 160 } }}>
            <Typography variant="body1" noWrap>
              {product.title}
            </Typography>
            {product.variantCombination && (
              <Typography variant="caption" color="text.secondary" display="block">
                {Object.entries(product.variantCombination).map(([key, value]) => 
                  `${key}: ${value}`
                ).join(', ')}
              </Typography>
            )}
            <Typography variant="overline">
              <PriceDisplay product={product} finalPrice={finalPrice} inCartDrawer />
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', justifyContent: { xs: 'flex-end', sm: 'flex-start' }, flexShrink: 0 }}>
            <CartActionsButton
              inCart={itemIds.includes(product._id)}
              layoutStyle="compact-icon-buttons"
              stock={product.stock}
              quantity={getQuantity(product._id, product.variantId)}
              onAdd={handleAdd}
              onRemove={handleRemove}
            />
          </Box>
        </Box>
      </CardContent>
    </Card>
    <Divider />
  </Fragment>
)

export default DrawerCartView
